import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerSW } from './swRegister';

import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

// 🔥 FIX за status bar
if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: false });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
registerSW();
